import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'desiredPriceRange',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class DesiredPriceRangePipe implements PipeTransform {
  transform(desiredPriceRangeFrom: number, desiredPriceRangeTo: number): string {
    return desiredPriceRangeTo || desiredPriceRangeFrom ? `$${desiredPriceRangeFrom} - $${desiredPriceRangeTo}` : '';
  }
}
